/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Constant import.
 */
import { INPUT_FILE, INPUT_FILLED } from '../../../app/constants/app.constants';

/**
 * Component used to create the multiple radio button with input and file.
 */
@Component({
  selector: 'app-multi-select-radio',
  templateUrl: './multi-select-radio.component.html',
  styleUrls: ['./multi-select-radio.component.scss']
})
export class MultiSelectRadioComponent {

  /**
   * Get the Options for radio.
   * Get the prefilled radio.
   * Get the question info.
   * Get the view only status.
   * Get the default text.
   * Get the placeholder for input type.
   * Get the file signed urls.
   */
  @Input() options;
  @Input() prefilled;
  @Input() question;
  @Input() isViewMode;
  @Input() defaultTxt;
  @Input() placeholder;
  @Input() fileSignedUrls;

  /**
   * Emit the selected radio.
   * Emit the other radio box.
   * Emit the zoom image src.
   */
  @Output() emitRadioBox: EventEmitter<{ event, name, isOtherOption, pty }> = new EventEmitter();
  @Output() emitOtherRadioBox: EventEmitter<{ event: string, value: string, name: string, validations }> = new EventEmitter();
  @Output() emitZoomImg: EventEmitter<string> = new EventEmitter();

  /**
   * Input filed constant.
   */
  public INPUT_FILE = INPUT_FILE;
  public INPUT_FILLED = INPUT_FILLED;

  /**
   * Get the selected radio status.
   */
  getSelectedRadioStatus(id, prefilled): boolean {
    return prefilled?.length ? (prefilled.some(val => id === val?.optionCode)) : false;
  }

  /**
   * Emit the selected radio selection.
   */
  setRadio(event, name, isOtherOption: boolean, pty): void {
    this.emitRadioBox.emit({ event, name, isOtherOption, pty });
  }

  /**
   * Emit the other option selection.
   */
  setRadioOtherOption(event: string, value: string, name: string, validations): void {
    this.emitOtherRadioBox.emit({ event, value, name, validations });
  }

  /**
   * Get the other selected values.
   */
  getOtherSelectedValue(id, prefilled): string {
    if (prefilled?.length) {
      const value = (prefilled.find(val => id === val?.optionCode));
      if (value) {
        return value.textValue;
      }
    }
    return '';
  }

  /**
   * Get the validation pattern.
   */
  getValidationPattern(input: string): string {
    let validation = null;
    switch (input) {
      case 'TEXT':
        validation = /^[a-z\s]+$/i;
        break;
      case 'ALPHANUMERIC':
        validation = /^[a-z\d\s]+$/i;
        break;
      case 'ALPHANUMERIC_SPL':
        validation = /^[`~!@#$%^&*()+-_\=\[\]{};':"\\|,<>.\/?a-z\d\s]+$/i;
        break;
      case 'NUMBER':
        validation = /^[0-9]*$/;
        break;

      default:
        break;
    }
    return validation;
  }

  /**
   * Emit the zoom Img src.
   */
  zoomImg(imgSrc: string): void {
    this.emitZoomImg.emit(imgSrc);
  }
}
